package org.hs_soft.runmynesto.pages.home.sub_page.media_center.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.dialog.AddRecordDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.home.sub_page.media_center.component.media_center_content.tabs.components.EditGroupDialog
import org.hs_soft.runmynesto.pages.home.sub_page.media_center.mvi.MediaCenterEvent
import org.hs_soft.runmynesto.pages.home.sub_page.media_center.mvi.MediaCenterState
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.AddProductToArticleDialog
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.DatePickerDialog


@Composable
fun MediaCenterDialogs(
    windowSizeMode: WindowSizeModeEnum,
    state: MediaCenterState,
    event: (MediaCenterEvent)->Unit,
) {
    if (state.showArticleDialog)
    {
        AddProductToArticleDialog(
            searchedProductItems=state.allProducts?: listOf(),
            onBackgroundClick = {
                event(MediaCenterEvent.SetArticleDialogStatus(false))
            },
            onItemClick = {
                event(MediaCenterEvent.AddItemToArticleList(it))
            }
        )
    }

    if (state.showAddGroupDialog)
    {
        EditGroupDialog(
            windowSizeMode=windowSizeMode,
            mediaTags = state.mediaTags,
            loading = state.editTagLoading,
            closeDialog = {
                event(MediaCenterEvent.SetAddNewGroupDialogStatus(false))
            },
            addTag = {name->
                event(MediaCenterEvent.AddTag(name))
            },
            deleteTag = {id->
                event(MediaCenterEvent.DeleteTag(id))
            },
        )
    }

    if (state.showAddRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().addNewMedia,
            nameFieldTitle = Strings.current().name,
            numberFieldTitle = Strings.current().number,
            numberHint = Strings.current().enterMediaNumber,
            nameHint = Strings.current().enterMediaName,
            nameValue = state.newRecordName,
            showNumberField = false ,
            isSubmitClickable = state.isAddNewRecordSubmitClickable,
            loading = state.addRecordLoading,
            onNameValueChange = {
                event(MediaCenterEvent.OnChangeRecordName(it))
            },
            onCancelClick = {
                event(MediaCenterEvent.OnCancelRecordDialogClick)
            },
            onSubmitClick = {
                event(MediaCenterEvent.OnSubmitRecordDialogClick(windowSizeMode))
            }
        ) {
            event(MediaCenterEvent.OnCancelRecordDialogClick)
        }
    }

    if (state.showFromCalendar) {

        DatePickerDialog(
            selectedDay = state.selectedFromDate,
            modifier = Modifier,
            calendarData = state.calendarData,
            onSelectDay = {
                event(MediaCenterEvent.OnSelectFromDate(it))
            },
            onBackgroundClick = {
                event(MediaCenterEvent.SetFromCalendarStatus(false))
            },
        )
    }

    if (state.showToCalendar) {

        DatePickerDialog(
            selectedDay = state.selectedToDate,
            modifier = Modifier,
            calendarData = state.calendarData,
            onSelectDay = {
                event(MediaCenterEvent.OnSelectToDate(it))
            },
            onBackgroundClick = {
                event(MediaCenterEvent.SetToCalendarStatus(false))
            },
        )
    }

    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode = windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(MediaCenterEvent.DismissErrorDialog)
            }
        )
    }

}